export const isChrome = () => {
  const userAgent = navigator.userAgent;
  
  // Check for Chrome (excludes other Chromium-based browsers like Edge)
  const isChromeBrowser = /Chrome/.test(userAgent) && !/Edge/.test(userAgent) && !/Edg/.test(userAgent);
  
  return isChromeBrowser;
};

export const getBrowserName = () => {
  const userAgent = navigator.userAgent;
  
  if (/Chrome/.test(userAgent) && !/Edge/.test(userAgent) && !/Edg/.test(userAgent)) {
    return 'Chrome';
  } else if (/Firefox/.test(userAgent)) {
    return 'Firefox';
  } else if (/Safari/.test(userAgent) && !/Chrome/.test(userAgent)) {
    return 'Safari';
  } else if (/Edge/.test(userAgent) || /Edg/.test(userAgent)) {
    return 'Edge';
  } else if (/Opera/.test(userAgent) || /OPR/.test(userAgent)) {
    return 'Opera';
  } else {
    return 'Unknown';
  }
}; 